import type {ReactNode} from 'react'
import {useFeatureFlag} from '@hooks/useFeatureFlag'
import type {FeatureFlag} from '@shared/constants/featureFlags'

interface Props {
  flag: FeatureFlag
  children: ReactNode
  fallback?: ReactNode
}

export function FeatureFlagGate({flag, children, fallback = null}: Props) {
  const enabled = useFeatureFlag(flag)
  return enabled ? <>{children}</> : <>{fallback}</>
}
